import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getTransactions = ({
  page,
  pageSize,
  search = '',
  orderBy,
  orderDirection,
  startDate,
  endDate,
}) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: '/transaction/list',
    data: {
      page,
      pageSize,
      search,
      orderBy,
      orderDirection,
      startDate,
      endDate,
    },
  });
